import React, { FC } from 'react';
import { InfoModal } from '../info-modal';
import style from './style.module.less';
import { Typography } from '@galaxy-ds/core';
import { LawyerConnectionUser } from '@law-connect/types';
import PhoneInput from 'react-phone-number-input';
import { UserAvatarComponent } from '../user-avatar';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  closeModal: () => void;
  user: LawyerConnectionUser;
}

export const UserInfoModal: FC<Props> = (props) => {
  const { isOpen, closeModal, user } = props;
  const { t } = useTranslation();
  if (!user) {
    return null;
  }

  const userName = user
    ? `${user.firstName || ''}${
      user.firstName?.length && user.lastName?.length ? ' ' : ''
    }${user.lastName || ''}`.trim() || 'Client'
    : 'Client';

  return (
    <InfoModal isOpen={isOpen} onClose={closeModal} 
      title={t('lawyer.view-information.contact-details')}>
      <div className={style.userInfoModalHeader}>
        <UserAvatarComponent user={user} userImageClassName={style.userImage} />
        <Typography variant='h2'>{userName}</Typography>
      </div>
      <div className={style.userInfoModalContent}>
        <div className={style.infoLabel}>
          <Typography variant='body2'>
            {t('lawyer.view-information.phone')}
          </Typography>
          <Typography variant='body2'>
            {t('lawyer.view-information.email')}
          </Typography>
        </div>
        <div className={style.infoData}>
          <div className={style.phone}>
            {/* <PatternFormat  
              value={user.phone}
              displayType={'text'}
              format={'(+##) ###-####'}
              allowEmptyFormatting={true}
            /> */}
            <PhoneInput
              value={user.phone}
              readOnly={true}
              onChange={() => {}}
              className={style.phoneInput}
            />
            {/* <Typography variant='body2'>{user.phone}</Typography> */}
          </div>
          <a href={`mailto:${user.email}`} className={style.email}>
            <Typography variant='body2'>{user.email}</Typography>
          </a>
        </div>
      </div>
    </InfoModal>
  );
};
